import { useState } from "react";
import { BookMarked, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export const SaveNote = ({ title, content, category = "advice", source = "manual", sourceRef = "", testId, className = "" }) => {
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/notebook", { title: title.slice(0, 120), content, category, source, source_ref: String(sourceRef).slice(0, 120) });
      setSaved(true);
      toast.success(data.already_saved ? "Already in your private Notebook" : "Saved to your private Notebook");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return <button data-testid={testId} onClick={save} disabled={busy || saved || !content?.trim()} className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition-colors hover:bg-amber-50 disabled:opacity-60 ${className}`}>
    {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : saved ? <Check className="h-3.5 w-3.5" /> : <BookMarked className="h-3.5 w-3.5" />}{saved ? "Saved to Notebook" : "Save to Notebook"}
  </button>;
};
